import { Dispatch } from 'redux'
import {
  set as setAction,
  update as updateAction
} from 'states/dux/user/actions'
import { Payload } from 'states/dux/user/types'
import { Action } from 'states/types'
import { NivosUser } from 'types/user'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (user: NivosUser): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setAction(user))
}

const update = (
  user: Partial<NivosUser>
): ((dispatch: Dispatch) => Action<Partial<Payload>>) => {
  return (dispatch: Dispatch): Action<Partial<Payload>> =>
    dispatch(updateAction(user))
}

export interface Operations {
  set: (user: NivosUser) => DispatchAction
  update: (
    user: Partial<NivosUser>
  ) => (dispatch: Dispatch) => Action<Partial<Payload>>
}

const operations: Operations = { set, update }

export { operations, set }
